// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".skeleton[data-v-340e0333]:before{animation:load-340e0333 1s cubic-bezier(.4,0,.2,1) infinite;background:linear-gradient(90deg,transparent 0,#e8e8e8 50%,transparent);content:\"\";display:block;height:100%;left:-150px;position:absolute;top:0;width:150px}@keyframes load-340e0333{0%{left:-150px}to{left:100%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
